
























import {Component, Vue, Prop} from "vue-property-decorator";
import { Project } from "@/models/project";
import { ProjectService } from "@/services/project-service";

@Component({
    name: 'TreeItem'
})
export default class TreeItem extends Vue{
    @Prop()
    project!: Project;

    isOpen = false;

    project_service: ProjectService = new ProjectService();

    get hasChild() {
        return (parseInt(this.project.rgt) - parseInt(this.project.lft) > 1)
    }

    toggle() {
        const tmp_project = this.project;
        if (this.hasChild) {
            this.project_service.getProjectChildren(tmp_project.id)
            .then((response) => {
                tmp_project.children = response.data;
                this.isOpen = !this.isOpen;
            })
        }
    }
}
